import delegate from 'delegate'

export default function () {
  delegate(document.body, 'a[href]', 'click', e => {
    var a = new RegExp('/' + window.location.host + '/|mailto\:')
    if (!a.test(e.delegateTarget.href)) {
      e.preventDefault()
      e.stopPropagation()
      window.open(e.delegateTarget.href, '_blank')
    }
  })
}